import { cn } from '@app/utils/cn';

import { Check, Minus } from '../Icons';

interface Props {
  isSelected?: boolean;
  isIndeterminate?: boolean;
  isDisabled?: boolean;
}

export const MenuItemCheckbox = ({ isSelected = false, isIndeterminate = false, isDisabled = false }: Props) => {
  return (
    <span
      className={cn('flex h-4 w-4 items-center justify-center rounded-small border border-neutral-80 transition-colors', {
        'group-hover:border-neutral-60': !isDisabled,
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        'bg-neutral-96/85': isDisabled,
        // eslint-disable-next-line sort-keys-fix/sort-keys-fix
        'border-neutral-20 bg-neutral-20 text-white': isSelected,
        'border-neutral-80 bg-neutral-80': isSelected && isDisabled,
        'group-hover:border-neutral-40 group-hover:bg-neutral-40': isSelected && !isDisabled,
      })}
    >
      {isSelected && <Check className="h-4 w-4" />}
      {isIndeterminate && <Minus className="h-4 w-4" />}
    </span>
  );
};
